export default "__VITE_ASSET__ChIe5CSR__"